// @flow
import { viewTicketActions } from "./viewTicketActionCreator";

const initialState = {
  ticketDetails: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  sendComments: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  commentDetails: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  assignToOptionsDetails: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  putTicketEscalation: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  validityDetails: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  ticketAction: {
    performingTicketAction: null,
    performedTicketAction: null,
    data: null,
    error: null
  }
};

const viewTicketReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case viewTicketActions.GET_TICKET_DETAILS: {
      return Object.assign({}, state, { ticketDetails: action.payload });
    }
    case viewTicketActions.SEND_COMMENTS: {
      return Object.assign({}, state, { sendComments: action.payload });
    }
    case viewTicketActions.GET_COMMENT_DETAILS: {
      return Object.assign({}, state, { commentDetails: action.payload });
    }
    case viewTicketActions.GET_ASSIGN_TO_OPTIONS: {
      return Object.assign({}, state, {
        assignToOptionsDetails: action.payload
      });
    }
    case viewTicketActions.PUT_TICKET_CHANGES: {
      if (action.payload.data)
        return Object.assign({}, state, {
          ticketDetails: action.payload
        });
      return Object.assign({}, state);
    }
    case viewTicketActions.POST_TICKET_ESCALATION_EMAIL: {
      return Object.assign({}, state, {
        putTicketEscalation: action.payload
      });
    }
    case viewTicketActions.CHECK_VALIDITY: {
      return Object.assign({}, state, {
        validityDetails: action.payload
      });
    }
    case viewTicketActions.TICKET_ACTION: {
      return Object.assign({}, state, { ticketAction: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default viewTicketReducer;



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/viewTicket/viewTicketRedux/viewTicketReducer.js